﻿import DefaultComponent from './components/display/default-component';
import HeroMapComponent from './components/display/hero-map-component';
import MapComponent from './components/display/map-component';
import MapModalComponent from './components/display/map-modal-component';
import Toast from './components/display/toast';
import ComponentFileInput from './components/form/fileinput-component';

/**
 * the slider is not currently used on the main site.
 * uncomment the import and bootstraping code blow to enable.
 */
//import SliderComponent from './components/display/slider-component';
//new SliderComponent('*[data-component="c-slider-component"]');

// const MapModalTemplates = [];
// MapModalTemplates.details = document.querySelector('[data-template="c-map-modal-component-details"]').innerHTML;

new ComponentFileInput("[data-component='c-file-input']", document);
 
if (typeof MAP_LOCATIONS !== 'undefined' && MAP_LOCATIONS.length) {
    MAP_LOCATIONS.forEach((location, index) => {
    
        // Add locations for HeroMapComponent
        $('.c-map__markers').append(`
            <div
                class="c-map__markers__marker"
                data-component="c-marker-component"
                data-marker-component-text="${location.marker.label}"
                data-marker-component-type="${location.marker.position}"
                data-marker-component-lat="${location.marker.lat}"
                data-marker-component-lng="${location.marker.lng}"
            ></div>
        `);
    
        
    });
    
    
    $('.c-modal').each(function() {
    
        const $detailsTemplate = $(this).find('[data-template="c-map-modal-component-details"]');
        const $bgTemplate = $(this).find('[data-template="c-map-modal-component-image"]');
        const $linkTemplate = $(this).find('[data-template="c-map-modal-component-link"]');
        const $linkLiTemplate = $(this).find('[data-template="c-map-modal-component-link-li"]');
        const $mapLinkTemplate = $(this).find('[data-template="c-map-modal-component-map"]');
    
        // MAP_LOCATIONS.forEach((location, index) => {
        // });
        for (let index = 0; index < MAP_LOCATIONS.length; index++) {
            const location = MAP_LOCATIONS[index];
    
            if ($detailsTemplate.length) {
                $detailsTemplate.before(
                    $detailsTemplate
                        .html()
                        .replace('{{category}}', location.category)
                        .replace('{{heading}}', location.title)
                        .replace('{{descript}}', location.content)
                )
            }
    
            if ($bgTemplate.length) {
                $bgTemplate.before(
                    $bgTemplate
                        .html()
                        .replace('{{styles}}', `background-image: url('${location.image}')`)
                );
            }
    
            if ($linkTemplate.length) {
    
                $linkTemplate.before(
                    $linkTemplate
                        .html()
                )
    
                var $list = $linkTemplate.prev().find('ul')
    
                if ($list.length && $linkLiTemplate.length) {
    
                    const linksQty = 3;
                    const indexStart = index + 1;
    
                    var links = [];
    
                    for (let i = indexStart; (i < MAP_LOCATIONS.length) && (i < indexStart + 3); i++) {
                        links.push({
                            ...MAP_LOCATIONS[i],
                            index: i
                        });
                    }
    
                    // 
                    if (links.length < linksQty) {
                        const diff = linksQty - links.length;
    
                        for (let i = 0; (i < index) && (i < diff); i++) {
                            links.push({
                                ...MAP_LOCATIONS[i],
                                index: i
                            });
                        }
                    }
    
                    links.forEach((linkLocation) => {
                        $list.append(
                            $linkLiTemplate
                                .html()
                                .replace('{{title}}', linkLocation.title)
                                .replace('{{descript}}', linkLocation.summary)
                                .replace('{{index}}', linkLocation.index)
                        );
                    })
                }
            }
    
            if ($mapLinkTemplate.length) {
                $mapLinkTemplate.before(
                    $mapLinkTemplate
                        .html()
                )
            }
    
            
        }
    
        $detailsTemplate.remove();
        $bgTemplate.remove();
        $linkTemplate.remove();
        $mapLinkTemplate.remove();
    
    });
}
 


new HeroMapComponent('*[data-component="c-hero-map-component"]'); 
new MapModalComponent('*[data-component="c-map-modal-component"]');

var maps = document.querySelectorAll('*[data-component="c-map-component"]'); 
for ( var i = 0; i < maps.length; i++ ) { 
    var map = $(maps[i]); 
    if(map.attr('data-map-component-type') == "normal"){
        new MapComponent(maps[i], i); 
    }
}





//
// NavBar
//

const navbar = document.querySelector("div.c-navbar");
const navbarToggler = document.querySelector(".navbar-toggler");

import Headroom from 'headroom.js';
import { link } from 'fs';
var navbarHeadroom  = new Headroom(navbar, {
    offset : 40,
    scroller: document.querySelector("div.app")
});
navbarHeadroom.init(); 


$(navbarToggler).click(function() {
    $(navbar).toggleClass('show-mobile-navbar');
});

function syncNavbarHeight() {
    var h = $(navbar).height();
    $('.navbar-height').height(h);
}

syncNavbarHeight()

window.addEventListener('resize', () => {
    syncNavbarHeight();
});


window.NGATI = {};

NGATI.Newsletter = (function () {
    var $email = $('#newsletterEmail');
    var $btnSubmit = $('.js-newsletter-btn');
    var $message = $('#js-newsletter-message');

    function formValidation() {
        var form = $('#js-newsletter-form')[0];
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
                return false;
            }
        }
    }

    function formSubmission() {

        $btnSubmit.on("click", function (event) {
            if (formValidation() == false) {
                $message.css({ 'color': 'red' });
                $message.html('Please enter your email address.');
                return false;
            }

            event.preventDefault();    

            var _model = {                
                "Email": $email.val()
            };

            var _url = '/umbraco/api/newsletter/subscribe';
            $.ajax({
                type: 'POST',
                url: _url,
                contentType: 'application/json',
                data: JSON.stringify(_model),
                success: function (response) {
                    console.log(response);
                    if (response.StatusCode == 400) {
                        $message.css({ 'color': 'red' });
                        $message.html(response.Message);
                    }
                    else {
                        $btnSubmit.hide();
                        $email.val(null);
                        $message.css({ 'color': 'white' });
                        $message.html(response.Message);
                    }

                },
                error: function (response) {
                    console.log(response);
                    $message.css({ 'color': 'red' });
                    $message.html('Something went wrong. Please try again later.');
                }
            });

            return false;
        });
    }

    return {
        init: function () {
            formSubmission();
        }
    };
}());

NGATI.Newsletter.init();